import { createContext, useContext, useState } from "react";
import { requestWithToken } from "../utils/apis";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => Boolean(localStorage.getItem("token"))
  );
  const [user, setUser] = useState({});

  const fetchUserDetails = async () => {
    const result = await requestWithToken("GET", "/api/user/me");
    console.log(result, "res")
    if (result?.data?.status === 0) {
      localStorage.removeItem("token");
      window.location.href = "/login";
      return;
    }
    if (result?.status === 200) {
      setUser(result.data.data);
      localStorage.setItem("access_menu", JSON.stringify(result.data.data?.access_menu));
      localStorage.setItem("access_permission", JSON.stringify(result.data.data?.access_permission));
      navigate(result.data.data?.access_menu[0]?.path);
    }
  };

  const login = () => {
    fetchUserDetails()
    setIsAuthenticated(true)
  };
  const logout = () => {
    setIsAuthenticated(false)
    // localStorage.removeItem("token")
       localStorage.clear();
    sessionStorage.clear();
    
  };


  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}
